module.exports = __webpack_public_path__ + "img/banner_news.ab910a1f.jpg";